if (!customElements.get('cart-upsell')) {
  customElements.define(
    'cart-upsell',
    class CartUpsell extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('.cart--upsell-slider');
        this.recommendationsContainer = this.querySelector('.product--HTML-container');
      }

      get remommendationsUrl() {
        if (!this.hasAttribute('data-recommendation-url')) return null;
        return this.dataset.recommendationUrl;
      }

      connectedCallback() {
        this.remommendationsUrl ? this.initRecommendations() : this.initSlider();
        document.body.addEventListener('switch:cart:afteradditem', () => {
          this.remommendationsUrl ? this.initRecommendations() : this.initSlider();
        });
      }

      initSlider() {
        if (!this.slider) return;
        const options = {
          slidesPerMove: 1,
          grabCursor: true,
          slidesPerView: 'auto',
          slidesOffsetAfter: 8,
          noSwiping: true,
          noSwipingClass: 'swiper-no-swiping',
          mousewheel: {
            forceToAxis: true,
          },
        };

        const swiper = new Swiper(this.slider, options);
      }

      initRecommendations() {
        this.getRecommendedProducts();
        document.body.addEventListener('switch:cart:afteradditem', () => this.getRecommendedProducts());
      }

      async getRecommendedProducts() {
        const response = await fetch(this.remommendationsUrl);
        const result = await response.text();
        const HTML = new DOMParser().parseFromString(result, 'text/html');
        const productsContainer = HTML.querySelector('.product--HTML-container');
        if (this.recommendationsContainer && productsContainer) {
          this.recommendationsContainer.innerHTML = productsContainer.innerHTML;
          this.initSlider();
        }
      }
    }
  );
}
